import React, { ReactElement } from "react";
import { Icon } from "@evergis/ui";

import { Separator, Descr } from "../styled";
import { styledHeaderSubTitleProps } from "../types";

export const styledHeaderSubTitle = ({
  layerName,
  step,
  uploadedFiles,
  toLayer,
  and,
}: styledHeaderSubTitleProps): ReactElement => (
  <Descr>
    {toLayer} <Icon kind={"geom_raster"} style={{ marginLeft: 4, marginRight: 2 }} /> {layerName}
    {step > 0 && !!uploadedFiles?.length && (
      <>
        <Separator />
        {uploadedFiles[0].name}
        {uploadedFiles.length > 1 && ` ${and} ${uploadedFiles.length - 1}`}
      </>
    )}
  </Descr>
);
